import React, { useState, useEffect } from 'react'
import { Popover, Row, Tooltip } from 'antd'

import { RequestUserData, FullRequestVehicle, Request } from 'src/types'

import { Alert, Button, Modal, Title } from 'src/components/Ant'
import UserAvatar from 'src/components/UserAvatar'

type Props = {
  item?: FullRequestVehicle
  onAdd(item: FullRequestVehicle): void
  toggle(): void
  visible: boolean
  request: Request
  loading?: boolean
  closeOnPick?: boolean
}

function SelectionModal({
  item,
  onAdd,
  toggle,
  visible,
  request,
  loading,
  closeOnPick = true
}: Props) {
  const [driver, setDriver] = useState<RequestUserData>()
  const [passengers, setPassengers] = useState<RequestUserData[]>([])
  const [users, setUsers] = useState<RequestUserData[]>([])
  const [error, setError] = useState<string>()

  useEffect(() => {
    if (visible) {
      const userCount = request.request_user_data.length

      setDriver(userCount === 1 ? { ...request.request_user_data[0] } : null)
      setPassengers([])
      setUsers(userCount === 1 ? [] : [...request.request_user_data])
    } else {
      setDriver(null)
      setPassengers([])
      setUsers([...request.request_user_data])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <Modal
      footer={[
        <Button
          data-test-id="vehicle-modal-add"
          loading={loading}
          key="add"
          onClick={() => {
            if (!driver) {
              setError(
                'web.services.vehicle.selection-form.users.error-driver-selection'
              )
              return
            }

            onAdd({
              ...item,
              travelers: [
                { owner: true, user_id: driver.traveler.user_id },
                ...passengers.map(passengerItem => ({
                  owner: false,
                  user_id: passengerItem.traveler.user_id
                }))
              ]
            })
            closeOnPick && toggle()
          }}
          size="default"
          title="common.actions.add"
        />
      ]}
      forceRender
      onCancel={toggle}
      onOk={() => {}}
      // title={<Text strong>{item && item.model}</Text>}
      visible={visible}
    >
      <Row>
        <Title level={4} title="web.services.vehicle.driver" />
        {!driver && (
          <Popover
            content={
              <>
                {users.map((userItem, index) => (
                  <Tooltip
                    key={userItem.traveler.user_id}
                    title={userItem.traveler.name}
                  >
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      data-test-id={`vehicle-result-modal-traveler-remove-${index}`}
                      onClick={() => {
                        setError(null)
                        setDriver({ ...userItem })
                        setUsers(
                          users.filter(
                            filterItem =>
                              filterItem.traveler.user_id !==
                              userItem.traveler.user_id
                          )
                        )
                      }}
                    >
                      <UserAvatar
                        gender={userItem.traveler.gender}
                        name={userItem.traveler.name}
                        size="large"
                        style={{ marginRight: 8 }}
                      />
                    </a>
                  </Tooltip>
                ))}
              </>
            }
            trigger="click"
          >
            <Button icon="plus" onClick={() => {}} shape="circle" />
          </Popover>
        )}
        {!!driver && (
          <Popover
            content={
              <Button
                icon="delete"
                onClick={() => {
                  setUsers([...users, { ...driver }])
                  setDriver(null)
                }}
                shape="circle"
                type="danger"
              />
            }
            trigger="click"
          >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={() => {}}>
              <UserAvatar
                gender={driver.traveler.gender}
                name={driver.traveler.name}
                size="large"
              />
            </a>
          </Popover>
        )}
      </Row>
      {(!!users.length || !!passengers.length) && (
        <Row style={{ marginTop: 16 }}>
          <Title
            level={4}
            title={JSON.stringify({
              message: 'web.services.vehicle.passenger',
              params: { count: passengers?.length || 1 }
            })}
          />
          {passengers.map(passengerItem => (
            <Popover
              key={passengerItem.traveler.user_id}
              content={
                <Button
                  icon="delete"
                  onClick={() => {
                    setUsers([...users, { ...passengerItem }])
                    setPassengers(
                      passengers.filter(
                        filterItem =>
                          filterItem.traveler.user_id !==
                          passengerItem.traveler.user_id
                      )
                    )
                  }}
                  shape="circle"
                  type="danger"
                />
              }
              trigger="click"
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a onClick={() => {}} style={{ marginRight: 16 }}>
                <UserAvatar
                  gender={passengerItem.traveler.gender}
                  name={passengerItem.traveler.name}
                  size="large"
                />
              </a>
            </Popover>
          ))}
          {!!users.length && (
            <Popover
              content={
                <>
                  {users.map(userItem => (
                    <Tooltip
                      key={userItem.traveler.user_id}
                      title={userItem.traveler.name}
                    >
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        onClick={() => {
                          setPassengers([...passengers, { ...userItem }])
                          setUsers(
                            users.filter(
                              filterItem =>
                                filterItem.traveler.user_id !==
                                userItem.traveler.user_id
                            )
                          )
                        }}
                      >
                        <UserAvatar
                          gender={userItem.traveler.gender}
                          name={userItem.traveler.name}
                          size="large"
                          style={{ marginRight: 8 }}
                        />
                      </a>
                    </Tooltip>
                  ))}
                </>
              }
              trigger="click"
            >
              <Button icon="plus" onClick={() => {}} shape="circle" />
            </Popover>
          )}
        </Row>
      )}
      {error && <Alert message={error} style={{ marginTop: 16 }} />}
    </Modal>
  )
}

export default SelectionModal
